
      import More from './more.vue'
      import type { App, Plugin } from 'vue'

      export const MorePlugin: Plugin = {
        install(app: App) {
          app.component('More', More)
        },
      }
      export { More }
      